export const taxUploadStoreKey = 'taxUpload';
